export const styles = {
	container: {
		width: '100%',
		px: { xs: 2, sm: 8, md: 12 },
		py: { xs: 2, sm: 4 },
		boxSizing: 'border-box',
	},
	helpText: {
		mb: 3,
	},
	helpTextSpan: {
		fontSize: 16,
	},
	requestButton: {
		width: { xs: '100%', sm: 'auto' },
		border: '1.5px solid #5B6B7A',
		borderRadius: '4px',
		background: '#fff',
		color: '#5B6B7A',
		fontWeight: 'bold',
		fontSize: { xs: 15, sm: 16 },
		px: { xs: 0, sm: 2 },
		py: 1.5,
		mt: 0.5,
		cursor: 'pointer',
		transition: 'background 0.2s',
		textDecoration: 'none',
		display: 'inline-block',
		'&:hover': {
			background: '#f5f7fa',
		},
	},
	accordionContainer: {
		mt: 6,
		backgroundColor: '#fff',
	},
}
